<template>
    <v-dialog v-model="dialog" max-width="900" persistent>
        <v-card>
            <v-card-title class="primary white--text title">
                {{ 'Parameter auto-tuner'|translate }}
            </v-card-title>
            <v-card-text class="pr-4 pl-4">
                <v-text-field :label="'Name'|translate" v-model="name"></v-text-field>
                <v-switch color="success" :label="'Active'|translate" v-model="active"></v-switch>
                <sensor-selector :label="'Target'|translate" v-model="target"></sensor-selector>
                <v-text-field :label="'Adjustment Frequency'|translate" v-model.number="adjustment_frequency"></v-text-field>
            </v-card-text>
            <v-card-title class="accent white--text subheading">{{ 'Config'|translate }}</v-card-title>
            <editor v-model="config" @init="editorInit" lang="json" theme="twilight" width="100%" height="500"></editor>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outline class="mr-2" @click="dialog=false">{{ 'Cancel'|translate }}</v-btn>
                <v-btn class="primary mr-2 elevation-4" @click="addRecord()" :disabled="!$can('update', 'Autotuner')">
                    {{ 'Save'|translate }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {putAutotuner} from '../helper'
import SensorSelector from "@/components/SensorSelector";
import editor from 'vue2-ace-editor'

export default {
    props: {
        value: {type: Boolean, default: true},
        item: {type: Object, default: null}
    },
    components: {SensorSelector,editor},
    watch: {
        item(item) {
            this.initializeVar()
            if (item) {
                let newItem=JSON.parse(JSON.stringify(item))
                if(newItem.config&&typeof(newItem.config)!=="string"){
                    newItem.config=JSON.stringify(newItem.config)
                }
                this.autotuner_id = newItem['autotuner_id']
                this.name = newItem['name']
                this.active = newItem['active']
                this.target = newItem['target']
                this.config = newItem['config']
                this.adjustment_frequency = newItem['adjustment_frequency']
            }
        },
        value() {
            if (this.dialog != this.value) {
                this.dialog = this.value
            }
        },
        dialog() {
            this.$emit('input', this.dialog)
        }
    },
    data() {
        return {
            dialog: false,
            autotuner_id: null,
            name: null,
            active: false,
            target: null,
            config: "",
            adjustment_frequency: 4,
        }
    },
    methods: {
        editorInit: function () {
            require('brace/ext/language_tools')
            require('brace/mode/json')
            require('brace/theme/twilight')
        },
        initializeVar() {
            this.autotuner_id = null
            this.name = null
            this.active = false
            this.target = null
            this.config = ""
            this.adjustment_frequency = 4
        },
        async addRecord() {
            await putAutotuner(
                {
                    'autotuner_id': this.autotuner_id,
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'name': this.name,
                    'active': this.active,
                    'target': this.target,
                    'config': this.config&&this.config!=="" ? JSON.parse(this.config) : null,
                    'adjustment_frequency': this.adjustment_frequency,
                }
            )
            this.$emit('doreload')
            this.dialog = false
        }
    },
    name: 'AutotunerDialog'
}
</script>

<style scoped>

</style>
